<div class="project-detail-dialog">
    <div class="dialog-header">
        <div>
            <h2>Projectdetails</h2>
            <h3>{{ data.project?.afas_project_id }}</h3>
        </div>
        <button class="close-button" (click)="onClose()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-content">
        <div class="project-info">
            <div class="data-cell strong">Naam</div>
            <div class="data-cell">{{ data.project?.name || '-' }}</div>
            <div class="data-cell strong">Locatie</div>
            <div class="data-cell">{{ data.project?.location || '-' }}</div>
            <div class="data-cell strong">{{ environment.executorName | ucFirst }}</div>
            <div class="data-cell">{{ data.executor?.name || '-' }}</div>
            <div class="data-cell strong">Projectleider</div>
            <div class="data-cell">{{ data.projectManager?.name || '-' }}</div>
        </div>
    </div>

    <div class="dialog-actions">
        <button (click)="onClose()" mat-button>Sluiten</button>
    </div>
</div>
